import React, { useState } from "react";
import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns";
import * as Icons from "../../HouseStyle/Icons";
import { ButtonBlue } from "../../HouseStyle/Components/Buttons";

const Dropdownfilter = ({ setFilters, filter }) => {
    const setFilterValue = (e) => {
        setFilters((filters) => {
            const newFilters = [...filters];
            newFilters[filters.findIndex((e) => e.index == filter.index)].value = e?.target?.value ?? e;
            return newFilters
        })
    }
    return <div className="d-flex w-100 h-100">
        <div className="bg-white rounded-4 p-4 h-100 border border-gray w-100">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="fw-bold mb-0">{filter.name}</h6>
                {filter.value && (
                    <img onClick={() => setFilterValue(null)} src={Icons.CloseDark} height={12} className="hover" />
                )}
            </div>
            <BorderedDropDown 
                selectedValue={String(filter.value)} 
                setSelectedValue={setFilterValue} 
                options={filter.options.map(e => {return {title: e.name, value: String(e.value)}})} 
                maxLength={16} 
                searchable={true} 
                placeholder={filter.placeholder || "Selecteer optie"}
            />
        </div>
    </div>
}

export default Dropdownfilter;